import React from "react";
import PredictionPage from "../../components/PredictionPage";

function GBPJPY() {
  return (
    <PredictionPage
      title="GBPJPY"
      content="This is the GBPJPY AI Trading Predictions page."
      canonical="/forex-minors/gbpjpy-ai-trading-predictions"
      categoryKey="nav.forexMinors"
      categoryPath="/forex-minors"
      symbol="GBPJPY"
    />
  );
}

export default GBPJPY;
